import request from '../utils/fetch';

//公共材质物理属性查询
export async function getPhysics(statisticSwitch?: boolean): Promise<any> {
  return request(`/boss/api/v1/material/public/physics/search`, {
    tokenFree: false,
    method: 'GET',
    params: {
      statisticSwitch,
    },
  });
}

//公共材质应用查询
export async function getApps(groupCode: string, statisticSwitch?: boolean): Promise<any> {
  return request(`/boss/api/v1/material/public/app/${groupCode}/search`, {
    tokenFree: false,
    method: 'GET',
    params: {
      statisticSwitch,
    },
  });
}

//公共材质创建
export async function addMaterial(params: any): Promise<any> {
  return request(`/boss/api/v1/material/public`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

//查询材质列表
export async function getMaterials(params: {
  appList?: any[];
  bizId?: string;
  categoryIds?: string[];
  name?: string;
  onlineStatus?: string;
  page: number;
  pageSize: number;
  sortType?: number;
  transferStatus?: string;
  businessCategoryIds?: string[];
}): Promise<any> {
  return request(`/boss/api/v1/material/public/search`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

//查询材质版本信息（详情）
export async function getDetailByVersionId(materialVersionId: string): Promise<any> {
  return request(`/boss/api/v1/material/public/${materialVersionId}`, {
    tokenFree: false,
    method: 'GET',
  });
}

//查询材质版本列表
export async function getMaterialVersions(materialId: string): Promise<any> {
  return request(`/boss/api/v1/material/public/${materialId}/version`, {
    tokenFree: false,
    method: 'GET',
  });
}

//设置当前版本
export async function updateMaterialVersion(
  materialId: string,
  materialVersionId: string,
): Promise<any> {
  return request(`/boss/api/v1/material/public/${materialId}/version/${materialVersionId}`, {
    tokenFree: false,
    method: 'PUT',
  });
}

//单个下载
export async function downMaterial(storageFileId: string, materialName: string): Promise<any> {
  return request(`/boss/api/v1/material/public/${storageFileId}/preview/presigned`, {
    tokenFree: false,
    method: 'GET',
    params: {
      materialName,
    },
  });
}

//材质上下架(支持批量)
export async function updateMaterialStatus(status: string, materialIds: string[]): Promise<any> {
  return request(`/boss/api/v1/material/public/status/${status}`, {
    tokenFree: false,
    method: 'PUT',
    data: {
      materialIds,
    },
  });
}

//批量修改材质分类
export async function updateMaterialCategory(params: {
  categoryId: string;
  materialVersionIds: string[];
  // updatedBy: string;
}): Promise<any> {
  return request(`/boss/api/v1/material/public/link/category`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

//更新材质
export async function updateMaterial(params: {
  categoryId: string;
  materialVersionId: string;
  length: number;
  md5: string;
  name: string;
  storageFileId: string;
  appList: string[];
  width: number;
  businessCategoryIds: string[];
}): Promise<any> {
  return request(`/boss/api/v1/material/public/${params.materialVersionId}`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

//材质删除(支持批量)
export async function deleteMaterial(ids: string[]): Promise<any> {
  return request(`/boss/api/v1/material/public/ids`, {
    tokenFree: false,
    method: 'DELETE',
    data: ids,
  });
}

//批量下载
export async function batchDownMaterial(
  params: {
    name: string;
    storageFileId: string;
  }[],
): Promise<any> {
  return request(
    `/boss/api/v1/material/public/file/zip/ids`,
    {
      tokenFree: false,
      method: 'POST',
      data: {
        materialDownloadDTOList: params,
      },
    },
    true,
  );
}

//批量修改材质应用
export async function updateMaterialApp(params: {
  appList: string[];
  materialVersionIds: string[];
}): Promise<any> {
  return request(`/boss/api/v1/material/public/link/app`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

//查询公共构件库标签树
export async function getComponentTags(): Promise<any> {
  return request(`/boss/api/v1/component/public/tag/list`, {
    tokenFree: false,
    method: 'GET',
  });
}

//查询公共构件应用
export async function getComponentApps(groupCode: string, statisticSwitch?: boolean): Promise<any> {
  return request(`/boss/api/v1/component/public/app/${groupCode}/search`, {
    tokenFree: false,
    method: 'GET',
    params: {
      statisticSwitch,
    },
  });
}

//创建公共构件库标签
export async function addComponentTag(params: { name: string; pid: string }): Promise<any> {
  return request(`/boss/api/v1/component/public/tag`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

//更新公共构件库指定标签
export async function updateComponentTag(params: { name: string; tagId: string }): Promise<any> {
  return request(`/boss/api/v1/component/public/tag/${params.tagId}`, {
    tokenFree: false,
    method: 'PUT',
    data: {
      name: params.name,
    },
  });
}

//查询公共构件库标签关联信息
export async function getComponentTagLink(tagId: string): Promise<any> {
  return request(`/boss/api/v1/component/public/tag/${tagId}/link`, {
    tokenFree: false,
    method: 'GET',
  });
}

//删除公共构件库指定标签
export async function deleteComponentTag(tagId: string, tagList?: any[]): Promise<any> {
  return request(`/boss/api/v1/component/public/tag/${tagId}`, {
    tokenFree: false,
    method: 'DELETE',
    data: tagList || [],
  });
}

//移动公共构件库标签到指定位置
export async function updateComponentTagPosition(params: {
  targetTagId: string;
  tagId: string;
}): Promise<any> {
  return request(`/boss/api/v1/component/public/tag/${params.tagId}/position`, {
    tokenFree: false,
    method: 'PUT',
    data: {
      targetTagId: params.targetTagId,
    },
  });
}

// 创建公共构件
export async function addComponent(
  list: {
    appList: string[];
    name: string;
    originSourceData: string;
    storageFileId: string;
    suffix: string;
    tagList: string[];
  }[],
): Promise<any> {
  return request(`/boss/api/v1/component/public`, {
    tokenFree: false,
    method: 'POST',
    data: {
      list,
    },
  });
}

//检索公共构件（带分页）
export async function getComponents(params: {
  appList: string[];
  name: string;
  orderBy?: string;
  status: string;
  suffix: string;
  tagList: string[];
  page: number;
  pageSize: number;
}): Promise<any> {
  return request(
    `/boss/api/v1/component/public/search?page=${params.page}&pageSize=${params.pageSize}`,
    {
      tokenFree: false,
      method: 'POST',
      data: params,
    },
  );
}

//更新构件信息
export async function updateComponent(params: {
  appList: string[];
  name: string;
  storageFileId?: string;
  suffix: string;
  tagList: string[];
  componentId: string;
  category: string;
  componentRelatedFiles: any[];
  adsorptionCategory?: string;
  extData?: any;
}): Promise<any> {
  return request(`/boss/api/v1/component/public/${params.componentId}`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

//批量删除构件
export async function deleteComponent(ids: string[]): Promise<any> {
  return request(`/boss/api/v1/component/public/ids`, {
    tokenFree: false,
    method: 'DELETE',
    data: ids,
  });
}

//批量上架-下架构件
export async function updateComponentLineStatus(params: {
  status: string;
  ids: string[];
}): Promise<any> {
  return request(`/boss/api/v1/component/public/status/${params.status}`, {
    tokenFree: false,
    method: 'PUT',
    data: params.ids,
  });
}

//构件单个下载
export async function getComponentDownUrl(
  storageFileId: string,
  componentName: string,
): Promise<any> {
  return request(`/boss/api/v1/component/public/${storageFileId}/preview/presigned`, {
    tokenFree: false,
    method: 'GET',
    params: { componentName },
  });
}

//查询公共构件版本
export async function getComponentVersions(componentId: string): Promise<any> {
  return request(`/boss/api/v1/component/public/${componentId}/version`, {
    tokenFree: false,
    method: 'GET',
  });
}

//设置公共构件当前版本
export async function updateComponentVersion(params: {
  componentId: string;
  versionId: string;
}): Promise<any> {
  return request(
    `/boss/api/v1/component/public/${params.componentId}/version/${params.versionId}`,
    {
      tokenFree: false,
      method: 'PUT',
    },
  );
}

//查询公共构件详情
export async function getComponentInfo(componentId: string): Promise<any> {
  return request(`/boss/api/v1/component/public/${componentId}`, {
    tokenFree: false,
    method: 'GET',
  });
}

//查询构件版本详情
export async function getComponentVersionInfo(versionId: string): Promise<any> {
  return request(`/boss/api/v1/component/public/version/${versionId}`, {
    tokenFree: false,
    method: 'GET',
  });
}

//查询需要的渲染模型信息（UE渲染交互）
export async function getComponentBase(modelId: string): Promise<any> {
  return request(`/boss/api/v1/component/public/view/model/${modelId}/base`, {
    tokenFree: false,
    method: 'GET',
  });
}

/**
 * 通过modelId获取构件属性(支持name筛选)
 */
export async function getElementDetailByModelIdApi(params: {
  modelId: string;
  name?: string;
  signature?: string;
}): Promise<any> {
  return request(`/boss/api/v1/component/public/elements/byModelId`, {
    method: 'GET',
    params: params,
  });
}

// 通过modelId获取模型转换状态
export async function getModelTransferStatusByModelIds(modelIds: any[]): Promise<any> {
  return request(`/model/v1/models/getModelTransferStatusByModelIds`, {
    method: 'POST',
    data: modelIds,
  });
}

//构件批量下载
export async function batchDownloadComponents(
  params: {
    name: string;
    storageFileId: string;
  }[],
): Promise<any> {
  return request(
    `/boss/api/v1/component/public/file/zip/ids`,
    {
      method: 'POST',
      data: {
        componentDownloadDTOList: params,
      },
    },
    true,
  );
}

//批量修改构件关联的标签
export async function updateComponentCategory(params: {
  componentIds: string[];
  tagList: string[];
}): Promise<any> {
  return request(`/boss/api/v1/component/public/link/tag`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

//批量修改构件关联的应用
export async function updateComponentApp(params: {
  componentIds: string[];
  appList: string[];
}): Promise<any> {
  return request(`/boss/api/v1/component/public/link/app`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

//查询公共材质标签树
export async function getMaterialTags(): Promise<any> {
  return request(`/boss/api/v1/material/public/business/category`, {
    tokenFree: false,
    method: 'GET',
  });
}

//创建公共材质库标签
export async function addMaterialTag(params: { name: string; pid: string }): Promise<any> {
  return request(`/boss/api/v1/material/public/business/category`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

//更新公共材质库指定标签
export async function updateMaterialTag(params: {
  name: string;
  categoryId: string;
}): Promise<any> {
  return request(`/boss/api/v1/material/public/business/category/${params.categoryId}`, {
    tokenFree: false,
    method: 'PUT',
    data: {
      name: params.name,
    },
  });
}

//删除公共材质库指定标签
export async function deleteMaterialTag(categoryId: string, tagList?: any[]): Promise<any> {
  return request(`/boss/api/v1/material/public/business/category/${categoryId}`, {
    tokenFree: false,
    method: 'DELETE',
    data: tagList || [],
  });
}

//移动公共材质库标签到指定位置
export async function updateMaterialTagPosition(params: {
  targetTagId: string;
  categoryId: string;
}): Promise<any> {
  return request(`/boss/api/v1/material/public/business/category/${params.categoryId}/position`, {
    tokenFree: false,
    method: 'PUT',
    data: {
      targetCategoryId: params.targetTagId,
    },
  });
}

//查询公共材质库标签关联信息
export async function getMaterialTagLink(categoryId: string): Promise<any> {
  return request(`/boss/api/v1/material/business/category/verify/${categoryId}/link`, {
    tokenFree: false,
    method: 'GET',
  });
}

//批量修改材质分类
export async function updateMaterialBusinessCategory(params: {
  businessCategoryIds: string[];
  materialIds: string[];
  // updatedBy: string;
}): Promise<any> {
  return request(`/boss/api/v1/material/link/business/category`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

//导出下载(支持批量)
export async function exportFileApi(ids: string[]): Promise<any> {
  return request('/boss/api/v1/component/public/file/export/ids', {
    method: 'POST',
    data: ids,
  });
}

//批量编辑构件信息
export async function batchUpdateComponents(params: {
  appList: string[];
  componentIds: string[];
  tagList: string[];
  extDataReqDTO: {
    adsorptionCategory: string;
    componentIds: string[];
    extData: any;
  };
}): Promise<any> {
  return request(`/boss/api/v1/component/public/component/ids`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}
